import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.EmailDomainXOrganizationEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.EmailDomainXOrganizationCreate })));

export default { edit, create };
